import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import NKIcon from '@norkart/ikoner'

export default ({ liste, forside }) =>
    
    <Link className="list-group-item arbeidsliste-element" to={'/utskiftning/' + liste.Id}>
        <div style={{ float: 'right', overflow: 'hidden' }}>
            <NKIcon icon="hoyrepil" color="nk-black" size="1" />
        </div>
        <div style={{ float: 'left', overflow: 'hidden', minHeight:'50px' }}>
            <div style={{ float: 'left', overflow: 'hidden', width: 70 + 'px' }}> 
                <span className='font15'>{liste.AntallSkifteteVannmaalere}</span> <strong className='font20'>/{liste.AntallVannmaalere}</strong>
            </div>
            <div style={{ float: 'left', overflow: 'hidden' }}>           
                <strong className='font16' style={{ paddingLeft: 0 + 'px' }}>{_.truncate(liste.Tittel,{'lenght':10})} </strong>
                {!forside
                    ? (
                        <p style={{ paddingLeft: 0 + 'px' }}>{_.truncate(liste.Beskrivelse,{'lenght':15})}</p>
                    )
                    : <div />
                }
            </div>
        </div>
        <div style={{ float: 'none', clear: 'both' }}></div>
    </Link>


// WEBPACK FOOTER //
// ./src/utskiftning/arbeidsliste-item.jsx